import { defineMessages } from 'react-intl';

import { KycDocumentType } from '#src/__generated__/globalTypes.ts';

export const kycDocumentTypeLabels = defineMessages<KycDocumentType>({
  [KycDocumentType.DRIVING_LICENSE]: {
    defaultMessage: "Driver's license",
  },
  [KycDocumentType.NATIONAL_ID]: {
    defaultMessage: 'National ID',
  },
  [KycDocumentType.PASSPORT]: {
    defaultMessage: 'Passport',
  },
  [KycDocumentType.NATIONAL_HEALTH_INSURANCE_CARD]: {
    defaultMessage: 'National health insurance card',
  },
  [KycDocumentType.RESIDENCE_PERMIT]: {
    defaultMessage: 'Residence permit',
  },
  [KycDocumentType.TAX_ID]: {
    defaultMessage: 'Tax ID',
  },
});

export const kycDocumentTypeLabelsWithPossessivePronoun =
  defineMessages<KycDocumentType>({
    [KycDocumentType.DRIVING_LICENSE]: {
      defaultMessage: "your driver's license",
    },
    [KycDocumentType.NATIONAL_ID]: {
      defaultMessage: 'your national ID',
    },
    [KycDocumentType.PASSPORT]: {
      defaultMessage: 'your passport',
    },
    [KycDocumentType.NATIONAL_HEALTH_INSURANCE_CARD]: {
      defaultMessage: 'your national health insurance card',
    },
    [KycDocumentType.RESIDENCE_PERMIT]: {
      defaultMessage: 'your residence permit',
    },
    [KycDocumentType.TAX_ID]: {
      defaultMessage: 'your tax ID',
    },
  });
